import { Component, Input, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MessageDialogModel } from "./models/incident-workflow-change-input.model";
import { MatButtonModule } from "@angular/material/button";
import { CerrixTitleComponent } from "@app/incident/components/src/lib/core/cerrix-title/cerrix-title.component";

@Component({
    selector: "cerrix-message-dialog",
    imports: [MatDialogModule, MatButtonModule, MatIconModule, CerrixTitleComponent],
    templateUrl: "./cerrix-message-dialog.component.html",
    styleUrl: "./cerrix-message-dialog.component.scss",
})
export class CerrixMessageDialogComponent {
    @Input() public dialogData: MessageDialogModel = inject(MAT_DIALOG_DATA);
}
